export default __webpack_public_path__ + "static/media/jan_coles.827afee1.jpg";